export default class Mutation {
  ctx
  params

  constructor (state, params) {
    this.state = state
    this.params = params
  }

  handle (ctx, params) {
    //
  }

  run () {
    return this.handle(this.state, this.params)
  }
}
